import TrendColor from './TrendColor';

export default TrendColor;
